module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-100"
  }, [_c('div', {
    staticClass: "border-bottom-medium pb-2 mb-2"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('label', [_vm._v("Extras:")]), _vm._v(" "), (_vm.transportDiference) ? _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Pax without transport'),
      expression: "'Pax without transport'"
    }],
    staticClass: "ico ico-alert color-6 mr-0 mt-1 fs-super text-center"
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "bold fs-smaller d-flex flex-column px-2 extra-name-container"
  }, _vm._l((_vm.bookingComponents), function(bookingComponent) {
    return _c('div', {
      staticClass: "mb-1"
    }, [(bookingComponent.quantity > 0 && (bookingComponent.quantityToAdd === 0 || bookingComponent.quantityToAdd === null || bookingComponent.quantityToAdd === undefined)) ? _c('div', [_c('span', {
      staticClass: "text-break"
    }, [_vm._v("\n                                " + _vm._s(bookingComponent.quantity) + " x " + _vm._s(bookingComponent.component.name + ' - ' + bookingComponent.componentPrice.name) + "\n                            ")])]) : (bookingComponent.id && bookingComponent.quantity > 0 && bookingComponent.quantityToAdd > 0) ? _c('div', {
      staticClass: "d-flex flex-column"
    }, [_c('span', {
      staticClass: "text-break"
    }, [_vm._v("\n                                " + _vm._s(bookingComponent.quantity - bookingComponent.quantityToAdd) + " x " + _vm._s(bookingComponent.component.name + ' - ' + bookingComponent.componentPrice.name) + "\n                            ")]), _vm._v(" "), _c('span', {
      staticClass: "dark text-break"
    }, [_vm._v("\n                                " + _vm._s(bookingComponent.quantityToAdd) + " x " + _vm._s(bookingComponent.component.name + ' - ' + bookingComponent.componentPrice.name) + "\n                            ")])]) : (!bookingComponent.id && bookingComponent.quantityToAdd > 0) ? _c('div', {
      staticClass: "d-flex flex-column"
    }, [_c('span', {
      staticClass: "dark text-break"
    }, [_vm._v("\n                                " + _vm._s(bookingComponent.quantityToAdd) + " x " + _vm._s(bookingComponent.component.name + ' - ' + bookingComponent.componentPrice.name) + "\n                            ")])]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('button', {
    staticClass: "btn secondary",
    attrs: {
      "disabled": _vm.disabled || _vm.isReservationReadOnly && _vm.reservation.status != -5
    },
    on: {
      "click": _vm.toggleViewExtas
    }
  }, [_vm._v("Edit")]), _vm._v(" "), _c('button', {
    staticClass: "btn secondary ml-2 text-nowrap",
    attrs: {
      "disabled": _vm.disabled || _vm.isReservationReadOnly && _vm.reservation.status != -5
    },
    on: {
      "click": _vm.toggleAddExtas
    }
  }, [_vm._v("+ Add Extras")])])])])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "d-flex justify-content-between align-items-center"
  }, [_c('label', {
    staticClass: "d-flex flexGrow1"
  }, [_vm._v("Voucher code:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.reservation.bookingOperatorCode),
      expression: "reservation.bookingOperatorCode"
    }],
    staticClass: "w-100 px-2 py-1 text-center bg-lighter",
    staticStyle: {
      "width": "200px !important"
    },
    attrs: {
      "disabled": _vm.disabled || _vm.isReservationReadOnly && _vm.reservation.status != -5,
      "type": "text"
    },
    domProps: {
      "value": (_vm.reservation.bookingOperatorCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.reservation, "bookingOperatorCode", $event.target.value)
      }
    }
  })])]), _vm._v(" "), (_vm.reservation.customer.bookingQuestion) ? _c('div', {
    staticClass: "border-bottom-medium pb-2 mb-2"
  }, [_c('div', {
    staticClass: "d-flexjustify-content-between align-items-center"
  }, [_c('label', {
    staticClass: "d-flex w-100 flexGrow1"
  }, [_vm._v(_vm._s(_vm.reservation.customer.bookingQuestion))])]), _vm._v(" "), _c('div', {
    staticClass: "dark"
  }, [(_vm.reservation.customer.bookingAnswer) ? _c('div', [_vm._v(_vm._s(_vm.reservation.customer.bookingAnswer))]) : _c('div', [_vm._v("No answer")])])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-29e3b2e9", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29e3b2e9"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEditV2/TabReservation/reservationOtherExtras.vue
// module id = 1911
// module chunks = 0